// extracted by mini-css-extract-plugin
export default {"titleFontSize":"skillScreenStyle_titleFontSize__RGxYG","skillStyle":"skillScreenStyle_skillStyle__8CUXF","titleColor":"skillScreenStyle_titleColor__cfoW1"};